import { gql } from "apollo-boost"

export const UPDATE_MINISTRATION = gql`
  mutation UpdateMinistration (
    $ministrationId: ID!
    $ministrationData: CreateMinistrationInput!
  ) {
    UpdateMinistration (
      ministrationId: $ministrationId
      createMinistrationData: $ministrationData
    ) {
      id
      totalSaved
      paymentDate
      paymentAmount
      paymentBreakdown
      suppliedBreakdown
      savedBreakdown
      totalSupplied
      totalNoSupplied
    }
  }
`